import { Wrapper } from 'components'
import { AuthContext } from 'contexts/AuthContext'
import { useContext, useState, useEffect } from 'react'
import { InitialValues } from './helper'
import { SimulatorsStep1 } from './step1'
import { SimulatorsStep2 } from './step2'
import { useNavigate, useParams } from 'react-router-dom'

import { simService } from 'api/services/sim'
import { productService } from 'api/services/product'
import { Card, Spinner } from 'keep-react'
import { ProductType } from 'api/types/product'
import { RouteNamesAuth } from 'routes/enum'

export const Simulators = () => {
  const [simData, setSimData] = useState<any>(null)
  const [product, setProduct] = useState<ProductType | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [currentStep, setCurrentStep] = useState<number>(1)
  const [holder, setHolder] = useState<any>('')

  const navigate = useNavigate()

  const { slug } = useParams<{ slug: string }>()
  const { currentBroker } = useContext(AuthContext)

  const [nif, setNif] = useState('')

  const [previousValues, setPreviousValues] = useState<InitialValues>({})

  const getSimulation = async () => {
    if (!slug) return
    try {
      const data = await simService.getSimulator(slug)
      setSimData(data.Product[0])
    } catch (error) {
      console.error('Error fetching simulator data:', error)
    }
  }

  const getProduct = async () => {
    if (!slug) return
    try {
      const response = (await productService.getPortalProduct({
        product: slug,
      })) as unknown as ProductType
      setProduct(response)
    } catch (error) {
      console.error('Error fetching product data:', error)
    }
  }

  useEffect(() => {
    getSimulation()
    getProduct()
    setCurrentStep(1)
    setNif('')
    setHolder('')
  }, [slug])

  useEffect(() => {
    if (product && simData) {
      setIsLoading(false)
    }
  }, [product, simData])

  useEffect(() => {
    if (currentBroker?.IsGroup) {
      navigate(RouteNamesAuth.DASHBOARD, { replace: true })
    }
  }, [currentBroker])

  const simulatorData = simData

  return (
    <div className="w-full flex-1 py-12 overflow-auto">
      <Wrapper>
        <h2 className="uppercase text-sm font-medium text-metal-900">
          Simulador
        </h2>
        <h1 className="pb-10 text-xxxl font-medium text-primary-600">
          {product?.description}
        </h1>

        {isLoading ? (
          <Card className="p-4 w-full max-w-full">
            <Spinner color="primary" className="mx-auto" />
          </Card>
        ) : !product || !simulatorData ? (
          <Card className="p-4 w-full max-w-full">
            <div className="text-heading-6 text-metal-400">
              Dados indisponíveis para este simulador.
            </div>
          </Card>
        ) : (
          <div>
            {currentStep === 1 && (
              <SimulatorsStep1
                setCurrentStep={setCurrentStep}
                setNif={setNif}
                setHolder={setHolder}
              />
            )}

            {currentStep === 2 && (
              <SimulatorsStep2
                nif={nif}
                holder={holder}
                simulatorData={simulatorData}
                previousValues={previousValues ? previousValues : undefined}
                conditions={product.simulatorConditions}
                setCurrentStep={setCurrentStep}
                helper={product.simulatorHelperText}
                productName={product.description}
              />
            )}
          </div>
        )}
      </Wrapper>
    </div>
  )
}
